export default Object.freeze({
  Default: 0,
  Today: 1,
  Yesterday: 2,
  Last7Days: 3,
  Last15Days: 4,
  Last30Days: 5,
  CurrentWeek: 6,
  CurrentMonth: 7,
  CurrentYear: 8,
  PreviousMonth: 9,
  Last3Months: 10,
  Last6Months: 11,
  Last12Months: 12,
  CustomRange: 13,
  Disabled: 14,
});
